<template>
  <!-- Blocage dur : une version trop ancienne pour le serveur (app_version_configs).
       Aucune sortie en production, le seul geste est le store. Le texte le dit
       sans détour, nomme le store, et rassure sur ce qui compte : rien n'est
       perdu. L'enfant peut la voir sur son téléphone : registre impersonnel. -->
  <AppSheet
    :is-open="modelValue"
    mode="centered"
    :backdrop-dismiss="false"
    backdrop-class="update-modal-backdrop"
  >
    <div class="update-modal-content flex flex-col items-center px-6 pb-6 text-center" data-testid="update-modal">
      <!-- Le logo sur son aplat, le bas en sourire, comme le bandeau de
           l'accueil (BrandSmileHero). Décoratif : le titre dit ce qui se passe. -->
      <div class="-mx-6 mb-5 flex h-32 items-center justify-center self-stretch rounded-b-[50%_28px] bg-(--color-logo-field) [@media(max-height:640px)]:mb-3 [@media(max-height:640px)]:h-22">
        <img src="/assets/icons/icon-256.webp" alt="" class="size-24 [@media(max-height:640px)]:size-18" draggable="false" />
      </div>

      <h2 class="font-display text-[22px] font-bold leading-tight text-ink text-balance">
        {{ $t('version.updateRequired') }}
      </h2>

      <p class="mt-2 text-[15px] leading-relaxed text-ink-2">
        {{ $t('version.updateMessage') }}
      </p>

      <div class="mt-4 flex w-full items-center gap-3 rounded-2xl bg-warm-2 px-4 py-3 text-left">
        <IconTile icon="shield-check" :size="36" :icon-size="18" tone="joy" />
        <p class="min-w-0 text-[13px] font-medium leading-snug text-ink">
          {{ $t('version.keepData') }}
        </p>
      </div>

      <Button class="mt-5 h-12 w-full" data-testid="update-modal-store" @click="$emit('update')">
        {{ storeLabel }}
      </Button>

      <button
        v-if="isDevelopment"
        type="button"
        class="mt-2 py-2 text-[13px] text-ink-3 active:opacity-70"
        @click="$emit('update:modelValue', false)"
      >
        {{ $t('version.ignoreDev') }}
      </button>
    </div>
  </AppSheet>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { Capacitor } from '@capacitor/core';
import { Button } from '@/components/ui/button';
import AppSheet from '@/components/common/AppSheet.vue';
import IconTile from '@/components/common/IconTile.vue';

defineProps<{
  modelValue: boolean;
}>();

defineEmits(['update', 'update:modelValue']);

const { t } = useI18n();
const isDevelopment = import.meta.env.DEV;

// Le bouton nomme le store où le geste mène.
const storeLabel = computed(() => {
  const platform = Capacitor.getPlatform();
  if (platform === 'ios') return t('version.updateOnAppStore');
  if (platform === 'android') return t('version.updateOnPlay');
  return t('version.updateNow');
});
</script>

<style>
.update-modal-backdrop {
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}
</style>
